class CollapsibleTabDrawer extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('.tab-drawer__trigger');
    this.overlay = this.querySelector('.tab-drawer__overlay');
    this.panel = this.querySelector('.tab-drawer__panel');
    this.closeButton = this.querySelector('.tab-drawer__close');

    if (this.trigger && this.overlay && this.panel && this.closeButton) {
      this.trigger.addEventListener('click', this.open.bind(this));
      this.closeButton.addEventListener('click', this.close.bind(this));
      this.overlay.addEventListener('click', this.close.bind(this));
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.panel.classList.contains('active')) {
          this.close();
        }
      });
    }
  }

open() {
  var header = document.querySelector('sticky-header, header-drawer, .header-wrapper, header');
  var headerHeight = header ? header.offsetHeight : 0;
  this.panel.style.top = headerHeight + 'px';
  this.panel.style.height = 'calc(100% - ' + headerHeight + 'px)';
  this.overlay.style.top = headerHeight + 'px';
  this.overlay.classList.add('active');
  this.panel.classList.add('active');
  document.body.classList.add('tab-drawer-open');

  var vitapuan = document.querySelector('#appstle-loyalty-button');
  if (vitapuan) vitapuan.style.display = 'none';
}

close() {
  this.overlay.classList.remove('active');
  this.panel.classList.remove('active');
  document.body.classList.remove('tab-drawer-open');
  this.trigger.focus();

  var vitapuan = document.querySelector('#appstle-loyalty-button');
  if (vitapuan) vitapuan.style.display = '';
}

}

if (!customElements.get('collapsible-tab-drawer')) {
  customElements.define('collapsible-tab-drawer', CollapsibleTabDrawer);
}
